.nav {
  font-size: var(--fs-sm);
}
.list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}
.item + .item::before {
  content: "/";
  margin-right: var(--sp-2);
  opacity: 0.5;
}
.item a {
  color: inherit;
}
